var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, ElementRef, Renderer2, AfterViewInit } from '@angular/core';
import { ViewService } from '../../view.service';
import { Select } from '@ngxs/store';
import { ViewState } from '../../state/view.state';
import { Observable } from 'rxjs';
var ViewHelpComponent = /** @class */ (function () {
    // ---------- Layout ----------
    function ViewHelpComponent(renderer, viewService) {
        this.renderer = renderer;
        this.viewService = viewService;
        // ---------- Class Variables ----------
        this.activeTab = 'basics';
    }
    ViewHelpComponent.prototype.ngOnInit = function () {
        this.initWindowSizeObserver();
    };
    ViewHelpComponent.prototype.ngAfterViewInit = function () {
        this.updateViewHeight();
    };
    // ---------- Layout ----------
    ViewHelpComponent.prototype.initWindowSizeObserver = function () {
        var _this = this;
        this.renderer.listen('window', 'resize', function () {
            _this.updateViewHeight();
        });
    };
    // Mobile devices have variable viewheight because the browser bar can scroll in and out of view
    // This workaround determines the available window space and uses that as a viewheight unit
    ViewHelpComponent.prototype.updateViewHeight = function () {
        var vh = window.innerHeight * 0.01;
        this.viewHelp.nativeElement.style.setProperty('--vh', vh + "px");
    };
    // ---------- Interactions ----------
    ViewHelpComponent.prototype.handleCloseClick = function () {
        this.viewService.toggleHelp(false);
    };
    ViewHelpComponent.prototype.handleTabClick = function (tab) {
        this.activeTab = tab;
    };
    __decorate([
        Select(ViewState.getCanTouch),
        __metadata("design:type", Observable)
    ], ViewHelpComponent.prototype, "canTouch$", void 0);
    return ViewHelpComponent;
}());
export { ViewHelpComponent };
